import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Card, Grid, } from '@mui/material';
import { Link } from 'react-scroll';
import { styled } from '@mui/material/styles';
import { useTokens } from '@mcn-platform/models';
import Paper from '@mui/material/Paper';
import Renderer from '../Renderer';
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    cursor: 'pointer',
    color: '#007bad',
    fontWeight: 700,
}));
const TabsWidget = ({ tabs, data, context, editData, _renderer, ...props }) => {
    const tokens = useTokens();
    return (_jsxs(Box, { sx: {
            width: '100%',
            backgroundColor: '#ff000  0',
        }, children: [_jsx(Box, { sx: {
                    flexGrow: 1,
                    mb: 1,
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#f5f5f5',
                    zIndex: 1,
                }, children: _jsx(Grid, { container: true, sx: { display: 'flex' }, spacing: 1, id: "containerDiv", children: tabs.map((tab, index) => {
                        const title = tab.titleTokenKey ? tokens.getToken(tab.titleTokenKey) : tab.title;
                        if (title === 'hide') {
                            return null;
                        }
                        return (_jsx(Grid, { item: true, xs: 4, children: _jsx(Link, { activeClass: "active", id: `tablink-${index}`, to: `div-${index}`, spy: true, smooth: true, offset: -65, children: _jsx(Item, { children: tab.titleTokenKey ? tokens.getToken(tab.titleTokenKey) : tab.title }) }) }, tab.key));
                    }) }) }), _jsx(Box, { children: tabs.map((tab, index) => {
                    const title = tab.titleTokenKey ? tokens.getToken(tab.titleTokenKey) : tab.title;
                    if (title === 'hide') {
                        return null;
                    }
                    return (_jsx(Stack, { sx: { mb: 1, scrollPaddingTop: '150px' }, id: `div-${index}`, children: _jsx(Card, { sx: { p: 2 }, children: _renderer ? _renderer(tab.config) : (_jsx(Renderer, { configId: tab.config, data: data, context: context, editData: editData })) }) }, tab.key));
                }) })] }));
};
TabsWidget.getChildren = (config) => (config.props.tabs.map((tab) => (tab.config)));
TabsWidget.meta = {
    group: 'hidden',
    name: 'Tabs',
    description: 'Display information in a set of tabs.',
    props: [],
    defaultConfig: {
        type: 'component',
        component: 'Tabs',
        props: {},
    },
};
export default TabsWidget;
//# sourceMappingURL=TabsWidget.js.map